import * as R from 'ramda';
import React, { useState } from 'react';
import { css } from '@emotion/react';
import { CircularProgress, Paper, Box, Button } from '@mui/material';
//import {  } from '@mui/icons-material';
import Markdown from 'react-markdown';
import { useQuery, usePostRequest, useQueryClient } from '@cd/react-query';
import { postJSONPS } from '@cd/utils';
import { either } from '@cd/utils';
import { useStore } from './store';
import { useHistory } from 'react-router-dom';
import LegalAcceptanceDone from './LegalAcceptanceDone';
import { useXProps } from '../xprops';

const wrapStyle = css({ display: 'flex', flexDirection: 'column' });

export function useGetAgreement(contractID) {
	const url = `/get/legal/contract/${contractID}`;
	const { dispatch } = useStore();

	return useQuery(['legalContract', contractID], () =>
		postJSONPS('GET', url).then(
			either(e => {
				dispatch({ type: 'post error', e });
				throw new Error(e);
			}, R.identity)
		)
	);
}

/** useCreateCharge ::  {} */
export function useSignAgreement(contractID) {
	const { dispatch } = useStore();
	const queryClient = useQueryClient();
	const { onAgreementSigned } = useXProps();

	const url = `/sign/agreement/${contractID}`;
	const retObj = usePostRequest({
		login: true,
		dispatch,
		url,
		successFn: (message, blob) => {
			setTimeout(() => {
				onAgreementSigned(false);
				dispatch({ type: 'post success', message });
				queryClient.invalidateQueries('legalContract');
			}, 0);
		}
	});

	return retObj;
}

const LegalSign = ({ contractID }) => {
	const { data } = useGetAgreement(contractID);
	const { mutate, isFetching: isFetching2 } = useSignAgreement(contractID);
	const history = useHistory();
	const [thankYou, setThankYou] = useState(false);

	if (!data) return <CircularProgress />;

	const finalData = R.isNil(data) || R.isEmpty(data) ? {} : data[0];
	const { contents, signed_date } = finalData;

	function onIAgree() {
		setThankYou(true);
		mutate({ contractID });
	}
	function onIDecline() {
		history.goBack();
	}

	return (
		<Paper css={wrapStyle}>
			{!thankYou && (
				<Markdown
					css={css({
						ol: { listStyle: 'decimal', marginLeft: '8px' },
						p: { padding: '6px 8px' },
						h2: { color: 'orange', margin: '32px 0 8px' },
						h3: { color: 'orange', margin: '32px 0 8px' },
						li: {
							marginTop: '8px',
							marginLeft: '24px',
							borderRadius: '4px',
							'p:first-child': {
								color: 'orange'
							}
						}
					})}>
					{contents}
				</Markdown>
			)}
			{!signed_date && !isFetching2 && (
				<Box
					sx={{
						p: 2,
						mt: 4,
						display: 'flex',
						justifyContent: 'space-between'
					}}>
					<Button onClick={e => onIDecline()} variant="outlined">
						I DECLINE
					</Button>
					<Button onClick={e => onIAgree()} variant="outlined">
						I ACCEPT
					</Button>
				</Box>
			)}
			{thankYou && <LegalAcceptanceDone />}
		</Paper>
	);
};
export default LegalSign;
